import React from 'react';
import PropTypes from 'prop-types';
import PerfectScrollbar from 'react-perfect-scrollbar';
import { IndustriesList } from './IndustriesList';

export const CitiesList = ({ onSelect, cities = [], cityData = {}, citySelected }) => (
    <PerfectScrollbar component="ul" className="map-menu--cities">
        {cities.map((city, index) => (
            <li
                key={index}
                onClick={() => onSelect(city)}
                className={
                    city === citySelected ? 'map-menu--cities-highlighted' : 'map-menu--city'
                }
            >
                <div>
                    <span>{city.toLowerCase() /* This gets capitalized in CSS */}</span>
                    <span className={city === citySelected ? 'menu-icon close' : 'menu-icon'} />
                </div>
                <IndustriesList
                    show={city === citySelected}
                    citySelected={citySelected}
                    facilities={cityData[city].facilities}
                    workers={cityData[city].workers}
                />
            </li>
        ))}
    </PerfectScrollbar>
);

CitiesList.props = {
    onSelect: PropTypes.func,
    cities: PropTypes.array,
    cityData: PropTypes.object,
    citySelected: PropTypes.string,
};
